/* The Aesthetic Cove — carries the name typed on the Christmas landing into the product page.

   The landing (christmas-landing.js) keeps the visitor's name in sessionStorage as
   "tac-gift-name". Here, once Globo Product Options has drawn its fields, that name goes into
   the field labelled exactly "Name", so nobody types it twice.

   It stays out of the way:
   - only a text field whose label is exactly "Name" (never "Personalisation", "Deliver To:",
     a textarea, or any second field);
   - only when the field is empty, and never again once the shopper has typed in it;
   - a short line under the field says where the name came from.
   If Globo redraws its fields (a colour or variant change), the name goes back in, on the
   same rules. Nothing is sent anywhere; Globo adds the name to the cart as it always has. */
(() => {
  let name = '';
  try { name = (sessionStorage.getItem('tac-gift-name') || '').trim(); } catch (e) { /* private mode: fall back to the link */ }
  // The landing's "Buy this bauble" link also carries the name, for browsers without sessionStorage.
  if (!name) name = (new URLSearchParams(location.search).get('name') || '').replace(/[^\p{L}\p{M}' ’.&-]/gu, '').trim().slice(0, 18);
  if (!name) return;

  const NOTE = 'Filled in from your Christmas list. Change it if this one is for someone else.';
  let touched = false;
  let filled = '';

  const findField = () => {
    for (const el of document.querySelectorAll('.gpo-element')) {
      const label = el.querySelector('.gpo-label');
      const input = el.querySelector('input[type="text"]');
      if (!label || !input) continue;
      if (label.textContent.replace(/[*:]/g, '').trim().toLowerCase() === 'name') return { el, input };
    }
    return null;
  };

  const fill = () => {
    if (touched) return;
    const found = findField();
    if (!found || found.input.dataset.giftName) return;
    const { el, input } = found;
    input.dataset.giftName = '1';
    input.addEventListener('input', (e) => { if (e.isTrusted) touched = true; });
    if (input.value.trim()) return;

    const max = input.maxLength > 0 ? input.maxLength : Infinity;
    filled = name.slice(0, max);
    input.value = filled;
    announce();

    if (!el.querySelector('.gift-name-note')) {
      const note = document.createElement('p');
      note.className = 'gift-name-note';
      note.textContent = NOTE;
      (input.closest('.gpo-input-wrap') || input).insertAdjacentElement('afterend', note);
    }
  };

  // Globo only saves a value it has heard change. Its fields appear before it starts listening,
  // so a name filled in straight away can show in the box and still be missing from the order.
  // So the change is announced again a few times after load, and once more as Add to cart is
  // pressed (capture phase, ahead of Globo). Never after the shopper has typed in the field.
  function announce() {
    if (touched || !filled) return;
    const found = findField();
    if (!found || found.input.value !== filled) return;
    found.input.dispatchEvent(new Event('input', { bubbles: true }));
    found.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  [600, 1500, 3000, 6000].forEach((ms) => setTimeout(announce, ms));
  window.addEventListener('pointerdown', (e) => { if (e.target.closest('[data-add-button]')) announce(); }, true);
  window.addEventListener('click', (e) => { if (e.target.closest('[data-add-button]')) announce(); }, true);
  window.addEventListener('submit', (e) => { if (e.target.matches('form[data-product-form]')) announce(); }, true);

  // Globo draws its fields after the page loads, inside the product form, so watch that form.
  const form = document.querySelector('form[data-product-form]') || document.body;
  new MutationObserver(fill).observe(form, { childList: true, subtree: true });
  fill();
})();
